import { color } from 'asserts/styles/colors';
import React from 'react';
import styled from 'styled-components';

interface InputBoxProps {
  placeholder: string;
  name: string;
  autoFocus?: boolean;
  autoComplete?: string;
  value: string;
  type: string;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
}

const InputBox = ({
  placeholder,
  name,
  autoFocus = false,
  value,
  type,
  autoComplete,
  onChange
}: InputBoxProps) => {
  return (
    <StyledInput
      placeholder={placeholder}
      name={name}
      autoFocus={autoFocus}
      value={value}
      type={type}
      autoComplete={autoComplete}
      onChange={onChange}
    />
  );
};

export default React.memo(InputBox);

const StyledInput = styled.input`
  width: 320px;
  height: 44px;
  border-radius: 22px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
  font-size: 14px;

  &::placeholder {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.3px;
  }

  &:first-of-type {
    margin-bottom: 12px;
  }

  &[type='text'] {
    padding-left: 20px;
  }

  &[type='password'] {
    padding-left: 20px;
  }

  &:focus {
    outline: none;
    border-color: ${color.mobile};
  }
`;
